<template>
  <div class="py-[60px] md:py-[80px] lg:py-[100px] xl:py-[150px]">
    <div
      class="container md:max-w-[960px] 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]"
    >
      <div class="text-center mx-auto md:max-w-[680px] lg:max-w-[830px]">
        <h2
          class="text-[28px] md:text-[36px] lg:text-[45px] xl:text-[48px] mb-[13px] md:mb-[20px] lg:mb-[25px] xl:mb-[35px] -tracking-[.5px] md:-tracking-[.8px] lg:-tracking-[1.2px] xl:-tracking-[1.5px] leading-[1.2]"
        >
          Unleash the Full Potential of Your Business with Click AI
        </h2>
        <p
          class="mx-auto leading-[1.6] md:max-w-[650px] lg:max-w-[680px] xl:max-w-[740px] md:text-[15px] lg:text-[16px] xl:text-[18px] xl:tracking-[.2px]"
        >
          Let ClickAI show you what the future looks like. Talk to our sales team and see how AI can take over the busywork – so you can focus on growing.


        </p>
        <RouterLink
          to="/contact"
          class="inline-block lg:text-[15px] xl:text-[16px] mt-[5px] md:mt-[10px] lg:mt-[20px] xl:mt-[30px] py-[12px] px-[17px] bg-purple-600 text-white rounded-md transition-all font-medium hover:bg-purple-500"
        >
          <span
            class="inline-block relative ltr:pl-[25px] rtl:pr-[25px] ltr:md:pl-[29px] rtl:md:pr-[29px]"
          >
            <i
              class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]"
            >
              contact_support
            </i>
            Contact us
          </span>
        </RouterLink>
      </div>
      <div
        class="absolute ltr:left-[10px] rtl:right-[10px] -top-[200px] -z-[1] blur-[150px]"
      >
        <img src="@/assets/images/front-pages/shape1.png" alt="shape1" />
      </div>
      <div
        class="absolute ltr:right-[25px] rtl:left-[25px] top-[150px] -z-[1] blur-[125px] hidden md:block"
      >
        <img src="@/assets/images/front-pages/shape2.png" alt="shape1" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CTA",
});
</script>
